import { render } from "./RequestInitiativeTtrRegistry.vue?vue&type=template&id=48470038&scoped=true"
import script from "./RequestInitiativeTtrRegistry.vue?vue&type=script&lang=js"
export * from "./RequestInitiativeTtrRegistry.vue?vue&type=script&lang=js"

import "./RequestInitiativeTtrRegistry.vue?vue&type=style&index=0&id=48470038&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48470038"]])

export default __exports__